import React, { useState, useEffect } from "react";
import moment from "moment";
import { IoMdSend } from "react-icons/io";
import {
  Grid,
  Button,
  Box,
  TextField,
  FormControl,
  InputLabel,
  Typography,
  TablePagination,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogContent,
} from "@material-ui/core";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import useStyles from "../../../../themes/style.js";
import { useNotification } from "../../../../hooks/useNotification.js";
import { GoDotFill, GoEye } from "react-icons/go";
import { IoClose } from "react-icons/io5";
import "../../../../css/certificate.css";
import NoDataFound from "../../../../components/NoDataFound/index.js";

export default function YetToReplyOpinions() {
  const classes = useStyles();
  const handleNotificationCall = useNotification();

  const token = localStorage.getItem("token");
  const [loader, setLoader] = useState(false);

  const [opinionData, setOpinionData] = useState([]);
  const [feedbackViewData, setFeedbackViewData] = useState({
    title: "",
    roleName: "",
    fullName: "",
    description: "",
    createdAt: "",
  });
  const [ViewOpinionsModalOpen, setViewOpinionsModal] = useState(false);
  const [replyModalOpen, SetReplyModalOpen] = useState(false);

  const handleReplyViewOpen = (item, type) => {
    if (type === "REPLY") {
      SetReplyModalOpen(true);
    } else {
      setViewOpinionsModal(true);
    }
    setFeedbackViewData({
      ...item,
      roleName: item.user.roleName,
      fullName: getEmpName(item.user),
    });

    reset();
  };

  const handleReplyViewClose = () => {
    SetReplyModalOpen(false);
  };

  const handleViewOpinoinsModalClose = () => {
    setViewOpinionsModal(false);
  };

  const [page, setPage] = useState(0);
  const [currerntPage, setCurrerntPage] = useState(1);
  const [count, setCount] = useState(0);

  const validationSchema = Yup.object().shape({
    reply: Yup.string().required("Reply is required"),
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    fetchFeedbackData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchFeedbackData = async () => {
    try {
      setLoader(true);
      axios({
        method: "post",
        url: `${process.env.REACT_APP_SERVER}opinions/viewAllOpinions`,
        data: {
          page: currerntPage,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).then(function (response) {
        if (response.data.status === true) {
          setLoader(false);
          setOpinionData(response.data.data);
          setCount(response.data.count);
        }
      });
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setLoader(true);
    setCurrerntPage(newPage + 1);

    var data = JSON.stringify({
      page: newPage + 1,
    });

    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}opinions/viewAllOpinions`,
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        setOpinionData(response.data.data);
        setCount(response.data.count);
      }

      setLoader(false);
    });
  };

  async function feedbackReply(values) {
    setLoader(true);
    console.log(values);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}opinions/reply`,
        {
          reply: values.reply,
          id: values.id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      setLoader(false);
      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
        fetchFeedbackData();
        handleReplyViewClose();
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  }

  function getEmpName(user) {
    let empName;
    if (user.employee) {
      empName = user.employee.firstName + " " + user.employee.lastName;
    }

    if (user.recruiter) {
      empName = user.recruiter.firstName + " " + user.recruiter.lastName;
    }
    return empName;
  }

  return (
    <div style={{ marginTop: "20px" }}>

      {opinionData.length <= 0 && (
         <NoDataFound height="80vh" message="No Data Found" />
      )}
      <Grid container spacing={2}>
        {opinionData.map((item) => (
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={4}
            key={item.id}
            style={{ minHeight: "100%", height: "max-contnet" }}
          >
            <article className="comment-card">
              <div className="opinions-type">
                <span>
                  <GoDotFill /> {item.type}
                </span>
                <div className="comment-date">
                  <time
                    dateTime={moment(item.createdAt).format("YYYY-MM-DD")}
                    title={moment(item.createdAt).format("Do MMMM YY")}
                  >
                    {moment(item.createdAt).format("MMM. DD, YYYY")}
                  </time>
                </div>
              </div>
              <div className="comment-footer">
                <div className="comment-author">
                  <div className="author-name">
                    <div className="author-name-container">
                      <span>{item.user.roleName}</span>
                      <span className="author-name">
                        {getEmpName(item.user)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <p className="comment-text comment-ques-title">{item.title}</p>
              <p className="comment-text">{item.description}</p>
              <div className="comment-actions">
                <button
                  type="button"
                  className="reply-button"
                  onClick={() => handleReplyViewOpen(item,"REPLY")}
                >
                  <svg
                    className="reply-icon"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 20 18"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 5h5M5 8h2m6-3h2m-5 3h6m2-7H2a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h3v5l5-5h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1Z"
                    />
                  </svg>
                  Reply
                </button>
                <button
                  type="button"
                  className="reply-button"
                  onClick={() => handleReplyViewOpen(item,"VIEW")}
                >
                  <GoEye className="reply-icon" />
                  View
                </button>
              </div>
            </article>
            {/* <Card
              style={{
                margin: "0.5rem",
                boxShadow:
                  "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
              }}
            >
              <CardContent>
               
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="flex-start"
                >
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="flex-start"
                  >
                    <Box>
                      <Typography
                        style={{ fontWeight: 700, color: "#116D6E" }}
                        variant="h6"
                      >
                        {item.user.roleName}
                      </Typography>
                    </Box>
                    <Box>
                      <Typography variant="h6">
                        {getEmpName(item.user)}
                      </Typography>
                    </Box>
                  </Box>
                  <Typography variant="h6" style={{ fontWeight: "bold" }}>
                    {item.type}
                  </Typography>
                </Box>

              
                <Grid
                  container
                  spacing={2}
                  alignItems="flex-start"
                  justifyContent="flex-start"
                >
                  <Grid item xs={12}>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      gutterBottom
                    >
                      {item.title}
                    </Typography>

                    <Typography
                      variant="body2"
                      component="p"
                      style={{
                        minHeight: "150px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "-webkit-box",
                        WebkitLineClamp: 6,
                        WebkitBoxOrient: "vertical",
                      }}
                    >
                      {item.description}
                    </Typography>
                  </Grid>
                </Grid>

                
                <Box
                  mt={3}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  gap={2}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleReplyViewOpen(item)}
                    startIcon={<FaReply />}
                    style={{ marginRight: "1rem", textTransform: "none" }}
                  >
                    Reply
                  </Button>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    gutterBottom
                  >
                    {moment(item.createdAt).format("Do MMM YY")}
                  </Typography>
                </Box>
              </CardContent>
            </Card> */}
          </Grid>
        ))}
      </Grid>
      <Grid container spacing={2} className={classes.pagination}>
        <TablePagination
          rowsPerPageOptions={[10]}
          component="div"
          count={count}
          rowsPerPage={10}
          page={page}
          onPageChange={handleChangePage}
        />
      </Grid>

      <Dialog
        open={replyModalOpen}
        fullWidth
        maxWidth="sm"
        onClose={handleReplyViewClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogContent>
          {/* Header */}
          <Box style={{ display: "flex", justifyContent: "end" }}>
            <div onClick={handleReplyViewClose} style={{ cursor: "pointer" }}>
              <IoClose size={22} />
            </div>
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="flex-start"
          >
            <Box display="flex" flexDirection="column" alignItems="flex-start">
              <Box>
                <Typography
                  style={{ fontWeight: 700, color: "#116D6E" }}
                  variant="h6"
                >
                  {feedbackViewData.roleName}
                </Typography>
              </Box>
              <Box>
                <Typography variant="h6">
                  {feedbackViewData.fullName}
                </Typography>
              </Box>
            </Box>
            <Typography variant="h6" style={{ fontWeight: "bold" }}>
              {feedbackViewData.type}
            </Typography>
          </Box>

          {/* Date Selection */}
          <Grid
            container
            spacing={2}
            alignItems="flex-start"
            justifyContent="flex-start"
          >
            <Grid item xs={12}>
              <Typography variant="body2" color="textSecondary" gutterBottom>
                {feedbackViewData.title}
              </Typography>

              <Typography variant="body2" component="p" style={{maxHeight:"260px",overflowY:"scroll"}}>
                {feedbackViewData.description}
              </Typography>
            </Grid>
          </Grid>

          {/* Action Buttons */}
          <Box
            mt={3}
            display="flex"
            justifyContent="end"
            alignItems="center"
            gap={2}
          >
            <Typography variant="body2" color="textSecondary" gutterBottom>
              {moment(feedbackViewData.createdAt).format("Do MMM YY")}
            </Typography>
          </Box>
          <form onSubmit={handleSubmit(feedbackReply)}>
            <Grid item xs={12} md={12} lg={12}>
              <InputLabel shrink htmlFor="description">
                Reply Message
              </InputLabel>
              <FormControl className={classes.margin}>
                <TextField
                  multiline
                  minRows={4}
                  size="small"
                  InputProps={{ disableUnderline: true }}
                  classes={{ root: classes.customTextField }}
                  placeholder="Enter your Feedback Message..."
                  name="reply"
                  {...register("reply")}
                  error={errors.reply ? true : false}
                />

                <TextField
                  name="id"
                  {...register("id")}
                  value={feedbackViewData.id}
                  style={{ display: "none" }}
                />

                <Typography variant="inherit" color="error">
                  {errors.reply?.message}
                </Typography>
              </FormControl>
            </Grid>
            <Box
              mt={3}
              display="flex"
              justifyContent="end"
              alignItems="center"
              gap={2}
            >
              <Button
                variant="contained"
                color="primary"
                type="submit"
                startIcon={<IoMdSend />}
                style={{ marginRight: "1rem", textTransform: "none" }}
              >
                Send
              </Button>
            </Box>
          </form>
        </DialogContent>
      </Dialog>

      <Dialog
        open={ViewOpinionsModalOpen}
        fullWidth
        maxWidth="sm"
        onClose={handleViewOpinoinsModalClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogContent>
          {/* Header */}
          <Box style={{ display: "flex", justifyContent: "end" }}>
            <div onClick={handleViewOpinoinsModalClose} style={{ cursor: "pointer" }}>
              <IoClose size={22} />
            </div>
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="flex-start"
          >
            <Box display="flex" flexDirection="column" alignItems="flex-start">
              <Box>
                <Typography
                  style={{ fontWeight: 700, color: "#116D6E" }}
                  variant="h6"
                >
                  {feedbackViewData.roleName}
                </Typography>
              </Box>
              <Box>
                <Typography variant="h6">
                  {feedbackViewData.fullName}
                </Typography>
              </Box>
            </Box>
            <Typography variant="h6" style={{ fontWeight: "bold" }}>
              {feedbackViewData.type}
            </Typography>
          </Box>

          {/* Date Selection */}
          <Grid
            container
            spacing={2}
            alignItems="flex-start"
            justifyContent="flex-start"
          >
            <Grid item xs={12}>
              <Typography variant="body2" color="textSecondary" gutterBottom>
                {feedbackViewData.title}
              </Typography>

              <Typography variant="body2" component="p">
                {feedbackViewData.description}
              </Typography>
            </Grid>
          </Grid>

          {/* Action Buttons */}
          <Box
            mt={3}
            display="flex"
            justifyContent="end"
            alignItems="center"
            gap={2}
          >
            <Typography variant="body2" color="textSecondary" gutterBottom>
              {moment(feedbackViewData.createdAt).format("Do MMM YY")}
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>
      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
